import { Component, ViewContainerRef, EventEmitter, Output } from '@angular/core';
import { MapService } from '../../../view/services/map.service';
import { environment } from "../../../../environments/environment";
import { LoginService } from "../../services/login/login.service";
import { MatDialog } from "@angular/material/dialog";
import { PanoramicService } from "../../../view/services/panoramic.service";
import { HomeComponent } from "../home/home.component";
import { BasemapGalleryComponent } from "../../../widgets/basemap-gallery/basemap-gallery.component";
import { LayersListComponent } from "../../../widgets/layers-list/layers-list.component";
import { SearchComponent } from "../../../widgets/search/search.component";
import { SelectComponent } from "../../../widgets/select/select.component";
import { MeasurementComponent } from "../../../widgets/measurement/measurement.component";
import { AddLayerComponent } from "../../../widgets/add-layer/add-layer.component";
import { OverviewMapComponent } from 'src/app/widgets/overview-map/overview-map.component';
import { PrintComponent } from 'src/app/widgets/print/print.component';
import { ComponentType } from '@angular/cdk/portal';
import Legend from "@arcgis/core/widgets/Legend";
import Editor from "@arcgis/core/widgets/Editor.js";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})

export class HeaderComponent {
  @Output() sidenavOpen = new EventEmitter();;

  legendView: boolean = false;
  editorView: boolean =  false;
  projectEnvironment = environment;
  currentCategory: any;
  currentLayer: any;
  currentForm: any;
  divMap: ViewContainerRef;
  tooltipDashboard = "Tablero de control";
  baseMapGallery: ComponentType<any> = BasemapGalleryComponent;
  layerList: ComponentType<any> = LayersListComponent;
  search: ComponentType<any> = SearchComponent;
  select: ComponentType<any> = SelectComponent;
  measurement: ComponentType<any> = MeasurementComponent;
  addLayer: ComponentType<any> = AddLayerComponent;
  overView: ComponentType<any> = OverviewMapComponent;
  print: ComponentType<any> = PrintComponent;
  //Posiciones predefinidas para la apertura de los widgets
  position = {
    topRight: { top: '75px', right: '60px' },
    bottomRight: { bottom: '60px', right: '110px' },
    topLeft: { top: '75px', left: '20px' },
    bottomLeft: { bottom: '60px', left: '20px' },
    middleLeft: { left: '20px' },
    top: { top: '75px' }
  };

  constructor(
    public mapService: MapService,
    public loginService: LoginService,
    protected dialog: MatDialog,
    protected panoramicService: PanoramicService,
    public homeComponent: HomeComponent,

  ) { }
  toggleSidenav() {
    this.sidenavOpen.emit();
  }

  changeCreateActive() {
    //verificar formulario activo
    if (this.panoramicService.getCreateActive())
      this.panoramicService.setCreateActive(false);
    else this.panoramicService.setCreateActive(true);
  }

  openDialog(id: string, component: ComponentType<unknown>, position?: {}) {
    if (!document.getElementById(id)) {
      this.dialog.open(component, { id: id, autoFocus: false, hasBackdrop: false, position: position });
    } else {
      this.dialog.getDialogById(id).close()
    }
  }

  toggleLegend() {
    const view = this.mapService.getViewMap()

    let legend = new Legend({
      container: document.createElement("div"),
      view: view,
      id: 'leyenda'
    });
    if (this.legendView) {
      view.ui.remove('leyenda');
      this.legendView = false;
    } else {
      view.ui.add(legend, 'top-right');
      this.legendView = true;
    }
  }

openEditor(){
  const view = this.mapService.getViewMap()
  const editor = new Editor({
    view: view,
    id :'editor'
  });
  
  if (this.editorView) {
    view.ui.remove('editor');
    this.editorView = false;
  } else {
    view.ui.add(editor, 'top-right');
    this.editorView = true;
  }
}

}
